import React from 'react';
import { Text as RNText, type TextProps as RNTextProps } from 'react-native';
import { twMerge } from 'tailwind-merge';

interface TextProps extends RNTextProps {
  children: React.ReactNode;
  className?: string;
}

const Text: React.FC<TextProps> = ({ children, className, ...rest }) => {
  return (
    <RNText className={twMerge(`font-normal`, className)} {...rest}>
      {children}
    </RNText>
  );
};

export default Text;
